import { Component, Input } from '@angular/core';
import { Customer } from 'src/app/api/customer/customer';

@Component({
    selector: 'customer-search-result-item',
    templateUrl: './customer-search-result-item.component.html',
    styleUrls: ['./customer-search-result-item.component.css'],
    standalone: false
})
export class CustomerSearchResultItemComponent {
  @Input() customer: Customer | null = null;
}
